export default __webpack_public_path__ + "resources/icons/d321-86b1.png";